import { render, staticRenderFns } from "./NewUiSpinner.vue?vue&type=template&id=5abd3ec3&"
import script from "./NewUiSpinner.vue?vue&type=script&lang=ts&"
export * from "./NewUiSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports